import { createColumnHelper } from '@tanstack/table-core';
import { ConversionPath } from '../paths.models';
import { PathPills } from './path-pills';
import { StickyOptions } from 'common/components/table/tableTypes';
import { CurrencyDisplayWrapper } from 'features/currency/currencyDisplayWrapper';
import { PathTime } from './path-time';

const columnHelper = createColumnHelper<ConversionPath>();
export const getPathsColumnDefs = (currencyCode: string) => [
  columnHelper.accessor((row) => row.chronologicalSources, {
    id: 'ChronologicalSources',
    header: () => 'Path',
    enableColumnFilter: false,
    cell: (info) => (
      <span className="text-xs">
        <PathPills sources={info.getValue()} />
      </span>
    ),
    meta: {
      stickyOptions: {
        isEnabled: true,
        side: 'left'
      } as StickyOptions
    },
    size: 350
  }),
  columnHelper.accessor((row) => row.conversionCount, {
    id: 'Conversions',
    header: () => 'Conversions',
    enableColumnFilter: false,
    cell: (info) => (
      <span className="text-sm">
        {Intl.NumberFormat('en-GB', {
          maximumFractionDigits: 2
        }).format(info.getValue())}
      </span>
    ),
    size: 100
  }),
  columnHelper.accessor((row) => row.totalSales, {
    id: 'TotalSales',
    header: () => 'Sales',
    enableColumnFilter: false,
    cell: (info) => (
      <span className="text-sm">
        {Intl.NumberFormat('en-GB', {
          maximumFractionDigits: 2
        }).format(info.getValue())}
      </span>
    ),
    size: 100
  }),
  columnHelper.accessor((row) => row.totalRevenue, {
    id: 'TotalRevenue',
    header: () => 'Revenue',
    enableColumnFilter: false,
    cell: (info) => (
      <span className="text-sm">
        <CurrencyDisplayWrapper currencyCode={currencyCode}>
          {Intl.NumberFormat('en-GB', {
            maximumFractionDigits: 2
          }).format(info.getValue())}
        </CurrencyDisplayWrapper>
      </span>
    ),
    size: 100
  }),
  columnHelper.accessor((row) => row.averageRevenue, {
    id: 'AverageRevnue',
    header: () => 'Avg Revenue',
    enableColumnFilter: false,
    cell: (info) => (
      <span className="text-sm">
        <CurrencyDisplayWrapper currencyCode={currencyCode}>
          {Intl.NumberFormat('en-GB', {
            maximumFractionDigits: 2
          }).format(info.getValue())}
        </CurrencyDisplayWrapper>
      </span>
    ),
    size: 100
  }),
  columnHelper.accessor((row) => row.timeToConversionInSecondsValues, {
    id: 'AverageTimeToConversion',
    header: () => 'Time To Conversion',
    enableColumnFilter: false,
    cell: (info) => {
      return (
        <span className="text-sm">
          <PathTime timeCalculationsInSeconds={info.getValue()} />
        </span>
      );
    }
  }),
  columnHelper.accessor((row) => row.averageTouchpointsToConversion, {
    id: 'TouchpointsToConversion',
    header: () => 'Touchpoints To Conversion',
    enableColumnFilter: false,
    cell: (info) => (
      <span className="text-sm">
        {Intl.NumberFormat('en-GB', {
          maximumFractionDigits: 2
        }).format(info.getValue())}
      </span>
    ),
    size: 175
  })
];
